import React from "react";

import Armatures from "../assets/Armatures.jpg";
import Resiflex from "../assets/Resiflex and Superdon Blades.jpg";
import WeldingMachines from "../assets/Welding Machines.jpg";
import Bearings from "../assets/Bearings.png";
import gardentools from"../assets/26.webp";
import pixelcat from "../assets/pixelcat.webp";

import "../styles/Catlog.css";

const Catlogs = () => {
  return (
    <div className="catlogs-page">
      <h1>Catalogues
      </h1>

      <div className="catlogs-container">
        <div className="catlog-item">
          <a
            href="https://pixeltools.in/pdfs/Pixelcatalogue.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={pixelcat} alt="Armatures" />
          </a>
          <h3>Pixel catlogue</h3>
        </div>

        <div className="catlog-item">
          <a
            href="https://pixeltools.in/pdfs/Weldingmachines.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={WeldingMachines} alt="Welding Machines" />  
          </a>
          <h3>Welding Machines</h3>
        </div>
            <div className="catlog-item">
          <a
            href="https://pixeltools.in/pdfs/Armature&Stator.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Armatures} alt="Armature & Stator" />
          </a>
          <h3>Armature & Stator</h3>
        </div>

        <div className="catlog-item">
          <a
            href="https://pixeltools.in/pdfs/Tctblades.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Resiflex} alt="Tct Blades" />
          </a>
          <h3>Tct& Diamond Blades</h3>
        </div>
    
      
              <div className="catlog-item">
          <a
            href="https://pixeltools.in/pdfs/Gardeningtools.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={gardentools} alt="Garden Tools" />
          </a>
          <h3>Garden Tools</h3>
        </div>
          <div className="catlog-item">
          <a
            href="https://pixeltools.in/pdfs/Bearings.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Bearings} alt="Bearings" />
          </a>
          <h3>Bearings</h3>
        </div>
      </div>
    </div>
  );
};

export default Catlogs;